import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { PopupType, closeAuthPopup } from '../../store/auth';
import { Button, Modal } from '../ui';
import ForgotPassword from './ForgotPassword';

interface IPopupType {
  title: string;
  component: JSX.Element;
  description?: string;
  hideCloseButton?: boolean;
}

type PopUps = {
  [key in PopupType]: IPopupType;
};
const AuthPopup: FC = () => {
  const { isPopupOpen, popupType } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(closeAuthPopup());
  };

  const popups: PopUps = {
    [PopupType.Forgot_Password]: {
      title: 'Reset your password',
      component: <ForgotPassword />,
      description: `Please provide your email address to start the password reset process. 
      We'll send you an email with instructions on how to reset your password securely.`,
    },
    [PopupType.Reset_Instructions]: {
      title: 'Password reset instructions sent',
      component: (
        <Button color="primary" fullWidth onClick={() => dispatch(closeAuthPopup())}>
          Back to Login
        </Button>
      ),
      description: `We have just sent you an email with instructions on how to reset your password.
        Simply follow the steps to regain access to your account.`,
      hideCloseButton: true,
    },
  };

  if (!popups[popupType]) {
    return null;
  }

  return (
    <Modal
      maxWidth="sm"
      isOpen={isPopupOpen}
      hideCloseButton={popups[popupType].hideCloseButton}
      close={closeModal}
      title={popups[popupType].title}
      description={popups[popupType].description}
    >
      {popups[popupType].component}
    </Modal>
  );
};

export default AuthPopup;
